import { render } from "./ModulosGestion.vue?vue&type=template&id=47da8015&scoped=true"
import script from "./ModulosGestion.vue?vue&type=script&lang=js"
export * from "./ModulosGestion.vue?vue&type=script&lang=js"

import "./ModulosGestion.vue?vue&type=style&index=0&id=47da8015&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47da8015"]])

export default __exports__